"use client";

import { useState } from "react";
import { Info } from "lucide-react";

/**
 * The "i" next to a codex property label: what the property means (data-forge
 * `prop.<key>.hint`, e.g. the game's own explanation of THAC0). Hover on desktop,
 * tap on touch screens.
 */
export function PropHint({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="group relative inline-flex align-middle">
      <button
        type="button"
        aria-label={text}
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setOpen(false)}
        className="text-muted-foreground hover:text-slate-200"
      >
        <Info className="h-3 w-3" />
      </button>
      <span
        role="tooltip"
        className={`${open ? "block" : "hidden"} group-hover:block absolute left-0 top-full z-50 mt-1 w-64 rounded border border-slate-700 bg-slate-950 p-2 text-xs font-normal normal-case leading-snug tracking-normal text-slate-200 shadow-lg`}
      >
        {text}
      </span>
    </span>
  );
}
